// Quantities per tier (EPS)
export const EPS_QTY = [4, 10, 50, 250, 999999999];
// Quantities per tier (FPM)
export const FPM_QTY = [0, 10, 100, 250, 999999999];
export interface Price {
  price: number;
}
